import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function Category08() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/offerbannerssort") // Update with actual backend URL
      .then((response) => {
        setData(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <section className="testimonials-category-section" style={{ paddingTop: "50px", paddingBottom:"20px" }}>
      <div className="tf-container">
        <div className="row">
          
          <div className="col-md-12">
            <div className="row">
              {data.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                  <div className="group-category-job padding wow fadeInUp" style={{paddingBottom:"10px"}}>
                    <div className="job-category-box" style={{width:"unset", padding:"0px"}}>
                      <div className="job-category-header" style={{marginBottom:"0px"}}>
                        <a href={item.Rurl || "#"}>
                        <img
                          src={item.Path1 || "default-image.jpg"} // Use Path1 for image
                          alt={item.Named}
                          style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                        />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Category08;